/**
 * hintText — turn a world prompt into a C5 hint slip.
 *
 * Scene manifests author prompts as full sentences ("Press E to read the
 * waystone") because the in-world prompt has no key badge. The slip DOES have
 * one, so repeating the key reads as a stutter: "E Press E to read...".
 * This strips the instruction prefix and leaves the verb phrase.
 *
 * Pure; tested without a harness.
 */

/** Matches "Press E to ", "press <space> to ", "Hold F to ", etc. */
const KEY_PREFIX = /^\s*(?:press|hold|tap)\s+(\S+?)\s+to\s+/i;

export interface HintParts {
  /** Key badge text, e.g. "E". */
  key: string;
  /** Verb phrase for the slip, e.g. "read the waystone". */
  label: string;
}

/**
 * Split a prompt into badge + label. Falls back to `defaultKey` and the whole
 * prompt when the sentence isn't in the "Press X to Y" shape.
 */
export function parseHint(prompt: string, defaultKey = 'E'): HintParts {
  const text = prompt.trim();
  const m = KEY_PREFIX.exec(text);
  if (!m) return { key: defaultKey, label: text };
  const label = text.slice(m[0].length).trim();
  if (label.length === 0) return { key: defaultKey, label: text };
  return { key: m[1].toUpperCase(), label };
}
